import { render, staticRenderFns } from "./Consolidation.vue?vue&type=template&id=db122394&scoped=true"
import script from "./Consolidation.vue?vue&type=script&lang=js"
export * from "./Consolidation.vue?vue&type=script&lang=js"
import style0 from "./Consolidation.vue?vue&type=style&index=0&id=db122394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db122394",
  null
  
)

export default component.exports